import {MeshBasicMaterial} from 'three/src/materials/MeshBasicMaterial';

export const LIGHT_HELPER_MAT = new MeshBasicMaterial({wireframe: true, fog: false});
